import { globals, breakpoint } from "./globalTheme"

const gridTheme = {
  row: {
    padding: 15,
  },
  col: {
    padding: 15,
  },
  container: {
    padding: 15,
    breakpoints: {
      sm: breakpoint.sm,
      md: breakpoint.md,
      lg: breakpoint.lg,
      xl: breakpoint.xl,
      xxl: breakpoint.xxl,
    },
    maxWidth: {
      xs: globals.containerXs,
      sm: globals.containerSm,
      md: globals.containerMd,
      lg: globals.containerLg,
      xl: globals.containerXl,
    },
  },
}

export default gridTheme
